export default __webpack_public_path__ + "static/media/mobileImage.128ed8a7.jpg";